import { Typography } from '@mui/material';
import React from 'react';

import { NAV_COLOR_PALETTE } from '../../Components/styleConstants';

export const SubmenuHeader: React.FC<{ headerText: string }> = ({ headerText }) => {
  return (
    <Typography variant="h4" noWrap={true} color={NAV_COLOR_PALETTE.primaryGray} sx={{ mx: 4, my: 1, fontWeight: 500 }}>
      {headerText}
    </Typography>
  );
};
